export default __webpack_public_path__ + "static/media/flag-tonga.72b70102.svg";